<template>
    <div class="w-full flex flex-wrap">
        <div class="mt-2 flex flex-col w-full">
            <div class="inline-block min-w-full py-2 align-middle">
                <div class="w-full shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                    <table class="table-default border-none" ref="table" v-if="levels && levels.length > 0">
                        <thead>
                            <tr class="border-none">
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.level'))" class="opacity-50"></th>
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.price_drop'))" class="opacity-50"></th>
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.fixed_time'))" class="opacity-50"></th>
                                <th v-if="!hideStatus" scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.status'))" class="opacity-50"></th>
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.price'))" class="opacity-50"></th>
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.qty_planned'))" class="opacity-50"></th>
                                <th scope="col" class="bg-white border-l border-r spacing-tab" ref="divider">&nbsp;</th>

                                <th
                                    scope="col"
                                    class="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase whitespace-normal tracking-wide text-gray-500 sm:pl-6 border-l"
                                    ref="dividerRight">{{$t('shared.pyramid_auction.levels.table_columns.level')}}</th>
                                <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.price_drop')}}</th>
                                <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.fixed_time')}}</th>
                                <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.new_price')}}</th>
                                <th scope="col" v-html="getText($t('shared.pyramid_auction.levels.table_columns.new_qty_planned'))"></th>
                            </tr>
                        </thead>
                        <tbody class="divide-y border-none bg-white">
                            <tr v-for="(level, index) in levels"
                                :key="level.id"
                                class="border-none"
                                :class="{
                                    'bg-gray-50': level.phase % 2 === 1,
                                    'price-drop': level.price_drop === 1 || index === 0
                                }">
                                <td class="py-4 text-sm font-medium text-gray-900 text-center opacity-50 border-t">{{level.sequence}}</td>
                                <td class="opacity-50 border-t"><icon v-if="level.price_drop === 1" name="badge-check" class="h-6 w-6"/></td>
                                <td class="opacity-50 border-t">{{ level.fixed_time | formatTime($t('locale.formatTimeTwelveHours'), tz.auctionTimeZone(), tz.code()) }}</td>
                                <td v-if="!hideStatus" class="px-3 py-4 text-sm text-gray-500 text-center opacity-50 border-t">
                                    <auction-state :state="level.state"></auction-state>
                                </td>
                                <td class="opacity-50 border-t">{{ level.price | toCurrency }}</td>
                                <td class="opacity-50 border-t">{{ level.quantity }}</td>
                                <td class="bg-white border-l border-r spacing-tab">&nbsp;</td>

                                <td class="border-t" :class="bgNew(level)">{{ level.new_sequence }}</td>
                                <td class="border-t" :class="bgNew(level)"><icon v-if="level.new_price_drop === 1" name="badge-check" class="h-6 w-6"/></td>
                                <td class="border-t" :class="bgNew(level)">{{ level.new_fixed_time | formatTime($t('locale.formatTimeTwelveHours'), tz.auctionTimeZone(), tz.code()) }}</td>
                                <td class="border-t" :class="bgNew(level)" v-if="!level.new_price"> </td>
                                <td class="border-t" :class="bgNew(level)" v-if="level.new_price">{{ level.new_price | toCurrency }}</td>
                                <td class="border-t" :class="bgNew(level)">{{ level.new_quantity }}{{ (level.adjusted || level.new_quantity < 0 ) ? '*' : ''}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!levels || levels.length < 1">{{$t('shared.pyramid_auction.levels.no_levels')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import PageHeadline from "@/Shared/PageHeadline";
import AuctionState from "@/Shared/Auction/AuctionState";
import TimeZoneService from "../../Services/TimeZoneService";


export default {
    components: {
        Link,
        Icon,
        PageHeadline,
        AuctionState
    },
    props: {
        levels: Array,
        forceHeaderSecondLine: {
            type: Boolean,
            default: false
        },
        hideStatus: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.resizeObserver = new ResizeObserver(() => {
            this.$emit('updated');
        });

        let that = this;
        this.$nextTick(() => {
            setTimeout(() => {
                that.resizeObserver.observe(that.$refs.table);
            }, 50);
        });
    },
    destroyed() {
        if(this.$refs.table) {
            this.resizeObserver.unobserve(this.$refs.table);
        }
    },
    methods: {
        getText(text) {
            if(this.forceHeaderSecondLine) {
                return text.replace(' ', '<br>');
            }
            return text;
        },
        getDimensions() {
            let left = this.$refs.divider.offsetLeft;
            let mid = this.$refs.dividerRight.offsetLeft;
            let total = this.$refs.table ? this.$refs.table.clientWidth : 0;
            return {
                'left': left,
                'mid': mid - left,
                'right': total - mid,
                'width': total
            };
        }
    },
    computed: {
        tz() {
            return TimeZoneService;
        },
        bgExisting(level) {
            return (level) => {
              return {
                  'bg-blue-100': level.price_drop === 1
              }
            };
        },
        bgNew(level) {
            return (level) => {
                return {
                    'bg-orange-100' : level.adjusted,
                }
            };
        }
    }
}
</script>
